import { toString as toString_1, Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { View_root as View_root_14, Types_initialModel as Types_initialModel_6, Types_Msg_$reflection as Types_Msg_$reflection_1, Types_Model_$reflection as Types_Model_$reflection_1 } from "./Page/AppOptions.fs.js";
import { View_root as View_root_8, State_update as State_update_3, Types_initialModel as Types_initialModel_8, Types_Msg_$reflection as Types_Msg_$reflection_7, Types_Model_$reflection as Types_Model_$reflection_2 } from "./Page/Sensor.fs.js";
import { View_root as View_root_10, State_update as State_update_5, Types_initialModel as Types_initialModel_9, Types_Msg_$reflection as Types_Msg_$reflection_3, Types_Model_$reflection as Types_Model_$reflection_3 } from "./Page/Sensors.fs.js";
import { View_root as View_root_12, State_update as State_update_6, Types_initialModel as Types_initialModel_11, Types_ReportKind as Types_ReportKind_1, Types_Msg_$reflection as Types_Msg_$reflection_4, Types_Model_$reflection as Types_Model_$reflection_4 } from "./Page/Status.fs.js";
import { View_root as View_root_11, State_update as State_update_7, Types_initialModel as Types_initialModel_10, Types_Msg_$reflection as Types_Msg_$reflection_5, Types_Model_$reflection as Types_Model_$reflection_5 } from "./Page/Monitoring.fs.js";
import { View_root as View_root_13, Types_Msg_$reflection as Types_Msg_$reflection_6, Types_Model_$reflection as Types_Model_$reflection_6 } from "./Page/Tags.fs.js";
import { record_type, obj_type, tuple_type, bool_type, option_type, class_type, list_type, string_type, union_type, int32_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { View_root as View_root_3, State_update as State_update_12, Types_initialModel as Types_initialModel_4, Types_Msg_$reflection as Types_Msg_$reflection_9, Types_Model_$reflection as Types_Model_$reflection_7 } from "./Page/Auth/Login.fs.js";
import { View_root as View_root_6, State_update as State_update_9, Types_initialModel as Types_initialModel_1, Types_Msg_$reflection as Types_Msg_$reflection_10, Types_Model_$reflection as Types_Model_$reflection_8 } from "./Page/Auth/ForgetPassword.fs.js";
import { View_root as View_root_4, State_update as State_update_10, Types_initialModel as Types_initialModel_2, Types_Msg_$reflection as Types_Msg_$reflection_11, Types_Model_$reflection as Types_Model_$reflection_9 } from "./Page/Auth/ChangePassword.fs.js";
import { View_root as View_root_5, State_update as State_update_11, Types_initialModel as Types_initialModel_3, Types_Msg_$reflection as Types_Msg_$reflection_12, Types_Model_$reflection as Types_Model_$reflection_10 } from "./Page/UpdatePassword.fs.js";
import { View_root as View_root_7, State_update as State_update_2, Types_initialModel as Types_initialModel_7, Types_Msg_$reflection as Types_Msg_$reflection_13, Types_Model_$reflection as Types_Model_$reflection_11 } from "./Page/Probe.fs.js";
import { View_root as View_root_9, State_update as State_update_4, Types_initialModel as Types_initialModel_5, Types_Msg_$reflection as Types_Msg_$reflection_14, Types_Model_$reflection as Types_Model_$reflection_12 } from "./Page/View.fs.js";
import { View_root as View_root_2, State_update as State_update_8, Types_initialModel, Types_Msg_$reflection as Types_Msg_$reflection_2 } from "./Page/Welcome.fs.js";
import { View_root as View_root_1, State_update as State_update_1, State_init as State_init_1, Types_Model_$reflection as Types_Model_$reflection_13, Types_Msg_$reflection as Types_Msg_$reflection_8 } from "./Page/Navbar.fs.js";
import { DATA_WINDOW_HOURS, Tag_$reflection, Auth_Response_$reflection, UserLight_$reflection, User_$reflection, GenericDocs$1_$reflection, Sensor_Status_$reflection, DataListSequence_$reflection, DataList_$reflection } from "./Shared.fs.js";
import { Secure_me, Secure_account, Secure_sensor, Secure_battery, Public_monthlyReport, Public_monthlyReportPDF, OutputKind, Secure_globalDataFromDateToDateCSV, Public_timeReport, Public_timeReportPDF, Secure_status, Auth_checkMagicLink, Secure_sensors, Secure_dataFromDateToDateCSV, Secure_dataFromDateToDate, Secure_probes, OutputKind_$reflection, FetchError_$reflection } from "./Fetch.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Types_Full_$reflection } from "../../iotpool-types/Project/Iotpool.Dotnet/fable/Library.fs.js";
import { LoginKind as LoginKind_1, Route, LoginKind_$reflection, Route_$reflection } from "./Types.fs.js";
import { Toastr_success, Toastr_message, Toastr_title, Toastr_showCloseButton, Toastr_timeout, Toastr_position, Toastr_withProgressBar, Toastr_error } from "./fable_modules/Elmish.Toastr.2.1.0/Elmish.Toastr.fs.js";
import { Cmd_none, Cmd_map, Cmd_batch, Cmd_OfPromise_either } from "./fable_modules/Fable.Elmish.3.1.0/cmd.fs.js";
import { empty, singleton, append, item, tail as tail_1, head, isEmpty, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { replace, toConsole, printf, toText, substring } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { Cmd_OfFunc_result } from "./fable_modules/Fable.Elmish.3.1.0/./cmd.fs.js";
import { curry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { toUniversalTime, hour as hour_5, toLocalTime, addDays, toString, year as year_13, now as now_4 } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { getMondayOfISOWeek } from "./Components/SensorFileDownload.fs.js";
import { Token_exists, User_set, Props_load, Props_Props, Props_set, Token_set, User_delete, Token_delete } from "./SessionStorage.fs.js";
import { modifyUrl } from "./Router.fs.js";
import { v } from "./Version.fs.js";
import { prepareFlat, prepare } from "./PDFWriter.fs.js";
import { map, toArray } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { FileInfo } from "./Fable.Import.JSZip.fs.js";
import * as zip from "./zip.js";
import { localFormat } from "./fable_modules/Fable.Date.1.0.0/Date.Format.fs.js";
import { french } from "./fable_modules/Fable.Date.1.0.0/Date.Local.fs.js";
import { parse } from "./fable_modules/fable-library-js.4.24.0/Int32.js";
import { item as item_1, map as map_1 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { Option, pageLoader as pageLoader_1 } from "./fable_modules/Fulma.Extensions.Wikiki.PageLoader.2.0.1/PageLoader.fs.js";
import { Size_ISize, Modifier_IModifier, TextAlignment_Option, Screen, Color_IColor } from "./fable_modules/Fulma.2.16.0/Common.fs.js";
import { h1 } from "./fable_modules/Fulma.2.16.0/Elements/Heading.fs.js";
import { Option as Option_1, container } from "./fable_modules/Fulma.2.16.0/Layouts/Container.fs.js";
import * as react from "react";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { body, Option as Option_2, hero } from "./fable_modules/Fulma.2.16.0/Layouts/Hero.fs.js";
import { Option as Option_3, icon } from "./fable_modules/Fulma.2.16.0/Elements/Icon.fs.js";
import { Fa_ISize, Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.2.0.0/FontAwesome.fs.js";

export class Types_ActivePage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AppOptions", "Sensor", "Sensors", "Status", "Monitoring", "SensorTags", "Welcome", "Login", "ForgetPassword", "ChangePassword", "UpdatePassword", "Probe", "View"];
    }
}

export function Types_ActivePage_$reflection() {
    return union_type("Main.Types.ActivePage", [], Types_ActivePage, () => [[["Item", Types_Model_$reflection_1()]], [["Item", Types_Model_$reflection_2()]], [["Item", Types_Model_$reflection_3()]], [["Item", Types_Model_$reflection_4()]], [["Item", Types_Model_$reflection_5()]], [["Item", Types_Model_$reflection_6()]], [["Item", int32_type]], [["Item", Types_Model_$reflection_7()]], [["Item", Types_Model_$reflection_8()]], [["Item", Types_Model_$reflection_9()]], [["Item", Types_Model_$reflection_10()]], [["Item", Types_Model_$reflection_11()]], [["Item", Types_Model_$reflection_12()]]]);
}

export class Types_ReportKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CSV", "PDF"];
    }
}

export function Types_ReportKind_$reflection() {
    return union_type("Main.Types.ReportKind", [], Types_ReportKind, () => [[], []]);
}

export class Types_Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AppOptionsMsg", "WelcomeMsg", "SensorsMsg", "StatusMsg", "MonitoringMsg", "TagsMsg", "SensorMsg", "NavbarMsg", "LoginMsg", "ForgetPasswordMsg", "ChangePasswordMsg", "UpdatePasswordMsg", "ProbeMsg", "ViewMsg", "OnLoadBattery", "OnLoadProbes", "OnLoadProbe", "OnLoadLatency", "OnLoadSensors", "OnLoadStatus", "OnLoadMonitoring", "OnLoadMonthlyReport", "OnLoadMonthlyReportForPDF", "OnLoadTimeReport", "OnLoadDateToDateReport", "OnLoadTimeReportForPDF", "OnLoadSensor", "OnLoadAccount", "OnLoadMe", "OnRefreshUser", "OnLoadMonthlyGlobalReport", "OnLoadWeeklyGlobalReport", "OnLoadSingleGlobalReportPDF", "OnDoneGlobalReportPDF", "OnLoadSingleGlobalReportCSV", "IgnoreMonthlyReportError", "IgnoreWeeklyReportError", "OnDisplayError", "OnDisplayErrorAndDisconnect", "OnDisplayFetchError", "OnDisplaySuccess", "OnCheckMagicLink"];
    }
}

export function Types_Msg_$reflection() {
    return union_type("Main.Types.Msg", [], Types_Msg, () => [[["Item", Types_Msg_$reflection_1()]], [["Item", Types_Msg_$reflection_2()]], [["Item", Types_Msg_$reflection_3()]], [["Item", Types_Msg_$reflection_4()]], [["Item", Types_Msg_$reflection_5()]], [["Item", Types_Msg_$reflection_6()]], [["Item", Types_Msg_$reflection_7()]], [["Item", Types_Msg_$reflection_8()]], [["Item", Types_Msg_$reflection_9()]], [["Item", Types_Msg_$reflection_10()]], [["Item", Types_Msg_$reflection_11()]], [["Item", Types_Msg_$reflection_12()]], [["Item", Types_Msg_$reflection_13()]], [["Item", Types_Msg_$reflection_14()]], [["Item1", string_type], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [DataList_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", DataList_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", Types_Full_$reflection()], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [DataListSequence_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", DataListSequence_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", string_type], ["Item2", string_type], ["Item3", string_type], ["Item4", union_type("Microsoft.FSharp.Core.FSharpResult`2", [DataList_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", DataList_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", string_type], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [DataList_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", DataList_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(string_type), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(string_type)]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [GenericDocs$1_$reflection(Sensor_Status_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", GenericDocs$1_$reflection(Sensor_Status_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [GenericDocs$1_$reflection(Sensor_Status_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", GenericDocs$1_$reflection(Sensor_Status_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", string_type], ["Item2", string_type], ["Item3", int32_type], ["Item4", int32_type], ["Item5", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", string_type], ["Item2", string_type], ["Item3", int32_type], ["Item4", int32_type], ["Item5", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", string_type], ["Item2", string_type], ["Item3", string_type], ["Item4", string_type], ["Item5", int32_type], ["Item6", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", Types_Full_$reflection()], ["Item2", string_type], ["Item3", string_type], ["Item4", OutputKind_$reflection()], ["Item5", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", string_type], ["Item2", string_type], ["Item3", string_type], ["Item4", string_type], ["Item5", int32_type], ["Item6", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", string_type], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Types_Full_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", Types_Full_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [User_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", User_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [UserLight_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", UserLight_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", Route_$reflection()], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [UserLight_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", UserLight_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", string_type], ["Item2", int32_type], ["Item3", int32_type], ["Item4", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", string_type], ["Item2", int32_type], ["Item3", int32_type], ["Item4", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item1", string_type], ["Item2", string_type], ["Item3", string_type], ["Item4", string_type], ["Item5", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", string_type]], [["Item1", string_type], ["Item2", string_type], ["Item3", string_type], ["Item4", string_type], ["Item5", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", class_type("System.Exception")]], [["Item", class_type("System.Exception")]], [["Item", class_type("System.Exception")]], [["Item", class_type("System.Exception")]], [["Item", FetchError_$reflection()]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Auth_Response_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", Auth_Response_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]]]);
}

export class Types_Model extends Record {
    constructor(ActivePage, Navbar, CurrentRoute, Count, IsLoading, User, UserData, Tags, LoginKind, FetchHours, GetGraphStartDate, GetGraphEndDate, Sensors, SensorsToDownload, CurrentReportIndex, PDFData) {
        super();
        this.ActivePage = ActivePage;
        this.Navbar = Navbar;
        this.CurrentRoute = CurrentRoute;
        this.Count = (Count | 0);
        this.IsLoading = IsLoading;
        this.User = User;
        this.UserData = UserData;
        this.Tags = Tags;
        this.LoginKind = LoginKind;
        this.FetchHours = (FetchHours | 0);
        this.GetGraphStartDate = GetGraphStartDate;
        this.GetGraphEndDate = GetGraphEndDate;
        this.Sensors = Sensors;
        this.SensorsToDownload = SensorsToDownload;
        this.CurrentReportIndex = CurrentReportIndex;
        this.PDFData = PDFData;
    }
}

export function Types_Model_$reflection() {
    return record_type("Main.Types.Model", [], Types_Model, () => [["ActivePage", option_type(Types_ActivePage_$reflection())], ["Navbar", Types_Model_$reflection_13()], ["CurrentRoute", option_type(Route_$reflection())], ["Count", int32_type], ["IsLoading", bool_type], ["User", option_type(string_type)], ["UserData", option_type(UserLight_$reflection())], ["Tags", option_type(list_type(Tag_$reflection()))], ["LoginKind", LoginKind_$reflection()], ["FetchHours", int32_type], ["GetGraphStartDate", string_type], ["GetGraphEndDate", string_type], ["Sensors", option_type(list_type(Sensor_Status_$reflection()))], ["SensorsToDownload", option_type(list_type(tuple_type(string_type, string_type)))], ["CurrentReportIndex", option_type(int32_type)], ["PDFData", option_type(list_type(tuple_type(string_type, obj_type)))]]);
}

export function displayError(errorMessage, model) {
    return [new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, false, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData), Toastr_error(Toastr_withProgressBar(Toastr_position("toast-top-full-width", Toastr_timeout(10000, Toastr_showCloseButton(Toastr_title("Erreur !", Toastr_message(errorMessage)))))))];
}

export function displaySuccess(model) {
    return [new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, false, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData), Toastr_success(Toastr_position("toast-top-full-width", Toastr_timeout(3500, Toastr_showCloseButton(Toastr_message("Succès !")))))];
}

export function displayCustomSuccess(msg, model) {
    return [new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, false, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData), Toastr_success(Toastr_position("toast-top-full-width", Toastr_timeout(3500, Toastr_showCloseButton(Toastr_message(msg)))))];
}

export function Commands_getResult(handler, response) {
    return handler(response);
}

export function Commands_getError(handler, response) {
    return handler(response);
}

export function Commands_getProbes(sensor, hours, model) {
    return [model, Cmd_OfPromise_either((tupledArg) => Secure_probes(tupledArg[0], tupledArg[1]), [sensor.Name, hours], (response) => ((tupledArg_1) => (new Types_Msg(15, [tupledArg_1[0], tupledArg_1[1]])))([sensor, response]), (response_1) => Commands_getError((Item_2) => (new Types_Msg(37, [Item_2])), response_1))];
}

export function Commands_getDataFromDateToDate(sensor, from, ending, model) {
    return [model, Cmd_OfPromise_either((tupledArg) => Secure_dataFromDateToDate(tupledArg[0], tupledArg[1], tupledArg[2]), [sensor.Name, from, ending], (response) => ((tupledArg_1) => (new Types_Msg(15, [tupledArg_1[0], tupledArg_1[1]])))([sensor, response]), (response_1) => Commands_getError((Item_2) => (new Types_Msg(37, [Item_2])), response_1))];
}

export function Commands_getDataFromDateToDateForDownload(parms_, parms__1, parms__2, parms__3, model) {
    const parms = [parms_, parms__1, parms__2, parms__3];
    const reportKind = parms[3];
    const full = parms[0];
    const from = parms[1];
    const ending = parms[2];
    return [model, Cmd_batch(ofArray([Cmd_OfPromise_either((tupledArg_1) => Secure_dataFromDateToDateCSV(tupledArg_1[0], tupledArg_1[1], tupledArg_1[2], tupledArg_1[3]), [full, from, ending, reportKind], (response) => ((tupledArg) => (new Types_Msg(24, [tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3], tupledArg[4]])))([full, from, ending, reportKind, response]), (response_2) => Commands_getError((Item_5) => (new Types_Msg(37, [Item_5])), response_2)), Cmd_OfPromise_either((tupledArg_2) => Secure_dataFromDateToDate(tupledArg_2[0], tupledArg_2[1], tupledArg_2[2]), [full.Name, from, ending], (response_1) => ((tupledArg_3) => (new Types_Msg(15, [tupledArg_3[0], tupledArg_3[1]])))([full, response_1]), (response_3) => Commands_getError((Item_8) => (new Types_Msg(37, [Item_8])), response_3))]))];
}

export function Commands_getSensors(model) {
    return [model, Cmd_OfPromise_either(Secure_sensors, undefined, (response) => Commands_getResult((Item) => (new Types_Msg(18, [Item])), response), (response_1) => Commands_getError((Item_1) => (new Types_Msg(37, [Item_1])), response_1))];
}

export function Commands_checkMagicLink(link, model) {
    return [model, Cmd_OfPromise_either(Auth_checkMagicLink, link, (response) => Commands_getResult((Item) => (new Types_Msg(41, [Item])), response), (response_1) => Commands_getError((Item_1) => (new Types_Msg(37, [Item_1])), response_1))];
}

export function Commands_getStatus(model) {
    return [model, Cmd_OfPromise_either(Secure_status, undefined, (response) => Commands_getResult((Item) => (new Types_Msg(19, [Item])), response), (response_1) => Commands_getError((Item_1) => (new Types_Msg(38, [Item_1])), response_1))];
}

export function Commands_getMonitoring(model) {
    return [model, Cmd_OfPromise_either(Secure_status, undefined, (response) => Commands_getResult((Item) => (new Types_Msg(20, [Item])), response), (response_1) => Commands_getError((Item_1) => (new Types_Msg(38, [Item_1])), response_1))];
}

export function Commands_getReport(parms_, parms__1, parms__2, parms__3, parms__4, parms__5, model) {
    const parms = [parms_, parms__1, parms__2, parms__3, parms__4, parms__5];
    const name = parms[0];
    const kind = parms[5];
    const from = parms[2];
    const ending = parms[3];
    const outputMsg = (kind.tag === 1) ? ((tupledArg_1) => (new Types_Msg(25, [tupledArg_1[0], tupledArg_1[1], tupledArg_1[2], tupledArg_1[3], tupledArg_1[4], tupledArg_1[5]]))) : ((tupledArg) => (new Types_Msg(23, [tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3], tupledArg[4], tupledArg[5]])));
    return [model, Cmd_OfPromise_either((kind.tag === 1) ? ((tupledArg_3) => Public_timeReportPDF(tupledArg_3[0], tupledArg_3[1], tupledArg_3[2])) : ((tupledArg_2) => Public_timeReport(tupledArg_2[0], tupledArg_2[1], tupledArg_2[2])), [name, from, ending], (response) => outputMsg([name, parms[1], from, ending, parms[4], response]), (response_1) => Commands_getError((Item_12) => (new Types_Msg(37, [Item_12])), response_1))];
}

export function Commands_getReportListed(reportKind, from, ending, model) {
    const fromTitle = substring(from, 0, from.indexOf("T"));
    const endingTitle = substring(ending, 0, ending.indexOf("T"));
    const title = toText(printf("IOTPOOL_%s_%s"))(fromTitle)(endingTitle);
    const matchValue = model.SensorsToDownload;
    if (matchValue == null) {
        return [model, Cmd_OfFunc_result(new Types_Msg(33, [title]))];
    }
    else {
        const list = matchValue;
        if (isEmpty(list)) {
            return [model, Cmd_OfFunc_result(new Types_Msg(33, [title]))];
        }
        else {
            const element = head(list);
            const name = element[0];
            const getResult = (handler, response) => handler([name, element[1], from, ending, response]);
            return [new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, true, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, tail_1(list), model.CurrentReportIndex, model.PDFData), (reportKind.tag === 1) ? Cmd_OfPromise_either((tupledArg_2) => Public_timeReportPDF(tupledArg_2[0], tupledArg_2[1], tupledArg_2[2]), [name, from, ending], curry2(getResult)((tupledArg_3) => (new Types_Msg(32, [tupledArg_3[0], tupledArg_3[1], tupledArg_3[2], tupledArg_3[3], tupledArg_3[4]]))), (response_2) => Commands_getError((Item_11) => (new Types_Msg(36, [Item_11])), response_2)) : Cmd_OfPromise_either((tupledArg) => Secure_globalDataFromDateToDateCSV(tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3]), [name, from, ending, new OutputKind(0, [])], curry2(getResult)((tupledArg_1) => (new Types_Msg(34, [tupledArg_1[0], tupledArg_1[1], tupledArg_1[2], tupledArg_1[3], tupledArg_1[4]]))), (response_1) => Commands_getError((Item_5) => (new Types_Msg(36, [Item_5])), response_1))];
        }
    }
}

export function Commands_getWeeklyReportListed(weekNumber, model) {
    const now = now_4();
    const title = toText(printf("semaine %i"))(weekNumber);
    const from = getMondayOfISOWeek(weekNumber, year_13(now));
    const ending = getMondayOfISOWeek(weekNumber + 1, year_13(now));
    const matchValue = model.SensorsToDownload;
    if (matchValue == null) {
        return [model, Cmd_OfFunc_result(new Types_Msg(33, [title]))];
    }
    else {
        const list = matchValue;
        if (isEmpty(list)) {
            return [model, Cmd_OfFunc_result(new Types_Msg(33, [title]))];
        }
        else {
            const element = head(list);
            return [new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, true, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, tail_1(list), model.CurrentReportIndex, model.PDFData), Cmd_OfPromise_either((tupledArg) => Public_timeReportPDF(tupledArg[0], tupledArg[1], tupledArg[2]), [element[0], from, ending], (response) => ((tupledArg_1) => (new Types_Msg(31, [tupledArg_1[0], tupledArg_1[1], tupledArg_1[2], tupledArg_1[3]])))([element[1], weekNumber, year_13(now), response]), (response_1) => Commands_getError((Item_4) => (new Types_Msg(36, [Item_4])), response_1))];
        }
    }
}

export function Commands_getMonthlyReportListed(month, model) {
    const now = now_4();
    let title;
    const arg = item(month - 1, ofArray(["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]));
    const arg_1 = year_13(now) | 0;
    title = toText(printf("%s %i"))(arg)(arg_1);
    const matchValue = model.SensorsToDownload;
    if (matchValue == null) {
        return [model, Cmd_OfFunc_result(new Types_Msg(33, [title]))];
    }
    else {
        const list = matchValue;
        if (isEmpty(list)) {
            return [model, Cmd_OfFunc_result(new Types_Msg(33, [title]))];
        }
        else {
            const element = head(list);
            return [new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, true, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, tail_1(list), model.CurrentReportIndex, model.PDFData), Cmd_OfPromise_either((tupledArg) => Public_monthlyReportPDF(tupledArg[0], tupledArg[1], tupledArg[2]), [element[0], month, year_13(now)], (response) => ((tupledArg_1) => (new Types_Msg(30, [tupledArg_1[0], tupledArg_1[1], tupledArg_1[2], tupledArg_1[3]])))([element[1], month, year_13(now), response]), (response_1) => Commands_getError((Item_4) => (new Types_Msg(35, [Item_4])), response_1))];
        }
    }
}

export function Commands_getMonthlyReport(parms_, parms__1, parms__2, parms__3, parms__4, model) {
    const parms = [parms_, parms__1, parms__2, parms__3, parms__4];
    const year = parms[3] | 0;
    const name = parms[0];
    const month = parms[2] | 0;
    const kind = parms[4];
    const outputMsg = (kind.tag === 1) ? ((tupledArg_1) => (new Types_Msg(22, [tupledArg_1[0], tupledArg_1[1], tupledArg_1[2], tupledArg_1[3], tupledArg_1[4]]))) : ((tupledArg) => (new Types_Msg(21, [tupledArg[0], tupledArg[1], tupledArg[2], tupledArg[3], tupledArg[4]])));
    return [model, Cmd_OfPromise_either((kind.tag === 1) ? ((tupledArg_3) => Public_monthlyReportPDF(tupledArg_3[0], tupledArg_3[1], tupledArg_3[2])) : ((tupledArg_2) => Public_monthlyReport(tupledArg_2[0], tupledArg_2[1], tupledArg_2[2])), [name, month, year], (response) => outputMsg([name, parms[1], month, year, response]), (response_1) => Commands_getError((Item_10) => (new Types_Msg(37, [Item_10])), response_1))];
}

export function Commands_getBattery(sensorId, model) {
    return [model, Cmd_OfPromise_either(Secure_battery, sensorId, (response) => ((tupledArg) => (new Types_Msg(14, [tupledArg[0], tupledArg[1]])))([sensorId, response]), (response_1) => Commands_getError((Item_2) => (new Types_Msg(37, [Item_2])), response_1))];
}

export function Commands_getSensor(sensorId, model) {
    return [model, Cmd_OfPromise_either(Secure_sensor, sensorId, (response) => ((tupledArg) => (new Types_Msg(26, [tupledArg[0], tupledArg[1]])))([sensorId, response]), (response_1) => Commands_getError((Item_2) => (new Types_Msg(37, [Item_2])), response_1))];
}

export function Commands_getAccount(model) {
    return [model, Cmd_OfPromise_either(Secure_account, undefined, (response) => ((Item) => (new Types_Msg(27, [Item])))(response), (response_1) => Commands_getError((Item_1) => (new Types_Msg(37, [Item_1])), response_1))];
}

export function Commands_getMe(model) {
    return [model, Cmd_OfPromise_either(Secure_me, undefined, (response) => ((Item) => (new Types_Msg(28, [Item])))(response), (response_1) => Commands_getError((Item_1) => (new Types_Msg(37, [Item_1])), response_1))];
}

export function Commands_refreshUser(route, model) {
    return [model, Cmd_OfPromise_either(Secure_me, undefined, (response) => ((tupledArg) => (new Types_Msg(29, [tupledArg[0], tupledArg[1]])))([route, response]), (response_1) => Commands_getError((Item_2) => (new Types_Msg(37, [Item_2])), response_1))];
}

export function State_Update_deleteToken(model) {
    Token_delete();
    User_delete();
    return new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, undefined, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData);
}

export function State_Update_setToken(token, model) {
    Token_set(token);
    return model;
}

export function State_Update_setTags(tags, model) {
    try {
        Props_set(new Props_Props(Props_load().StatusTableMode, tags));
    }
    catch (matchValue) {
        Props_set(new Props_Props(false, tags));
    }
    return new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData);
}

export function State_Update_setUser(uid, user, model) {
    User_set(uid);
    return new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, uid, user, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData);
}

export function State_Update_load(model) {
    return new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, true, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData);
}

export function State_Update_loadFinished(model) {
    return new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, false, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData);
}

export function State_Update_activePage(activePage, route, model) {
    return [new Types_Model(activePage, model.Navbar, model.CurrentRoute, model.Count, false, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData), modifyUrl(route)];
}

export function State_Update_routeMessage(activePage, mapper, command, model) {
    return [new Types_Model(activePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData), Cmd_map(mapper, command)];
}

export function State_setRoute(optRoute_mut, model_mut) {
    let matchValue;
    State_setRoute:
    while (true) {
        const optRoute = optRoute_mut, model = model_mut;
        const model_1 = new Types_Model(model.ActivePage, model.Navbar, optRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData);
        toConsole(printf("OMG the next route is %A"))(optRoute);
        if (optRoute == null) {
            const matchValue_2 = model_1.User;
            if (matchValue_2 == null) {
                optRoute_mut = (new Route(10, [""]));
                model_mut = model_1;
                continue State_setRoute;
            }
            else {
                const user_1 = matchValue_2;
                optRoute_mut = (new Route(7, []));
                model_mut = model_1;
                continue State_setRoute;
            }
        }
        else {
            switch (optRoute.tag) {
                case 7:
                    return State_Update_activePage(new Types_ActivePage(6, [Types_initialModel]), new Route(7, []), model_1);
                case 0:
                    return State_Update_activePage(new Types_ActivePage(8, [Types_initialModel_1]), new Route(0, []), model_1);
                case 8: {
                    const code = optRoute.fields[0];
                    return State_Update_activePage(new Types_ActivePage(9, [Types_initialModel_2(code)]), new Route(8, [code]), model_1);
                }
                case 1:
                    return State_Update_activePage(new Types_ActivePage(10, [Types_initialModel_3]), new Route(1, []), model_1);
                case 10: {
                    const kind = optRoute.fields[0];
                    if (Token_exists()) {
                        return Commands_getStatus(model_1);
                    }
                    else {
                        let lk;
                        const matchValue_1 = kind.toLowerCase();
                        lk = ((matchValue_1 === "mg") ? (new LoginKind_1(1, [])) : ((matchValue_1 === "occion") ? (new LoginKind_1(2, [])) : (new LoginKind_1(0, []))));
                        const model_8 = new Types_Model(model_1.ActivePage, model_1.Navbar, model_1.CurrentRoute, model_1.Count, model_1.IsLoading, model_1.User, model_1.UserData, model_1.Tags, lk, model_1.FetchHours, model_1.GetGraphStartDate, model_1.GetGraphEndDate, model_1.Sensors, model_1.SensorsToDownload, model_1.CurrentReportIndex, model_1.PDFData);
                        return State_Update_activePage(new Types_ActivePage(7, [Types_initialModel_4(lk)]), new Route(10, [kind.toLowerCase()]), model_8);
                    }
                }
                case 13: {
                    const code_1 = optRoute.fields[0];
                    return State_Update_activePage(new Types_ActivePage(12, [Types_initialModel_5(code_1)]), new Route(13, [code_1]), model_1);
                }
                case 9: {
                    const link = optRoute.fields[0];
                    return Commands_checkMagicLink(link, model_1);
                }
                case 2:
                    return Commands_getSensors(model_1);
                case 12: {
                    const sensor = optRoute.fields[0];
                    return Commands_getBattery(sensor, model_1);
                }
                case 5:
                    return Commands_getMonitoring(new Types_Model(model_1.ActivePage, model_1.Navbar, model_1.CurrentRoute, model_1.Count, model_1.IsLoading, model_1.User, model_1.UserData, model_1.Tags, model_1.LoginKind, DATA_WINDOW_HOURS, model_1.GetGraphStartDate, model_1.GetGraphEndDate, model_1.Sensors, model_1.SensorsToDownload, model_1.CurrentReportIndex, model_1.PDFData));
                case 4:
                    return Commands_getStatus(new Types_Model(model_1.ActivePage, model_1.Navbar, model_1.CurrentRoute, model_1.Count, model_1.IsLoading, model_1.User, model_1.UserData, model_1.Tags, model_1.LoginKind, DATA_WINDOW_HOURS, model_1.GetGraphStartDate, model_1.GetGraphEndDate, model_1.Sensors, model_1.SensorsToDownload, model_1.CurrentReportIndex, model_1.PDFData));
                case 14: {
                    const moduleName = optRoute.fields[0];
                    const month = optRoute.fields[2] | 0;
                    const realName = optRoute.fields[1];
                    const year = optRoute.fields[3] | 0;
                    return Commands_getMonthlyReport(moduleName, realName, month, year, new Types_ReportKind(0, []), model_1);
                }
                case 15: {
                    const moduleName_1 = optRoute.fields[0];
                    const month_1 = optRoute.fields[2] | 0;
                    const realName_1 = optRoute.fields[1];
                    const year_1 = optRoute.fields[3] | 0;
                    return Commands_getMonthlyReport(moduleName_1, realName_1, month_1, year_1, new Types_ReportKind(1, []), model_1);
                }
                case 16: {
                    const ending = optRoute.fields[3];
                    const from = optRoute.fields[2];
                    const moduleName_2 = optRoute.fields[0];
                    const realName_2 = optRoute.fields[1];
                    const weekNUmber = optRoute.fields[4] | 0;
                    return Commands_getReport(moduleName_2, realName_2, from, ending, weekNUmber, new Types_ReportKind(0, []), model_1);
                }
                case 17: {
                    const ending_1 = optRoute.fields[3];
                    const from_1 = optRoute.fields[2];
                    const moduleName_3 = optRoute.fields[0];
                    const realName_3 = optRoute.fields[1];
                    const weekNumber = optRoute.fields[4] | 0;
                    return Commands_getReport(moduleName_3, realName_3, from_1, ending_1, weekNumber, new Types_ReportKind(1, []), model_1);
                }
                case 11: {
                    const key = optRoute.fields[0];
                    return Commands_getSensor(key, model_1);
                }
                case 18: {
                    const probeId = optRoute.fields[1];
                    const probeKind = optRoute.fields[2];
                    const sensorId = optRoute.fields[0];
                    return [model_1, Cmd_none()];
                }
                case 6:
                    return Commands_getStatus(model_1);
                default:
                    return State_Update_activePage(new Types_ActivePage(0, [Types_initialModel_6((matchValue = model_1.UserData, (matchValue == null) ? undefined : matchValue.AppOptions))]), new Route(3, []), model_1);
            }
        }
        break;
    }
}

export function State_init(location) {
    const arg = v();
    toConsole(printf("***IOTPOOL v%s***"))(arg);
    const patternInput = State_setRoute(location, new Types_Model(undefined, State_init_1(), undefined, 0, false, undefined, undefined, undefined, new LoginKind_1(0, []), DATA_WINDOW_HOURS, toString(addDays(now_4(), -1), "yyyy-MM-dd"), toString(now_4(), "yyyy-MM-dd"), undefined, undefined, undefined, undefined));
    return [patternInput[0], patternInput[1]];
}

export function State_nextPage(route, model) {
    return State_setRoute(route, model);
}

export function State_handleGetError(model, _arg) {
    switch (_arg.tag) {
        case 1:
            return displayError(_arg.fields[0], model);
        case 2:
            return displayError(_arg.fields[0], model);
        default:
            return displayError(toText(printf("Erreur code %i : %s"))(_arg.fields[0])(_arg.fields[1]), model);
    }
}

export function State_update(msg, model) {
    let matchValue_8, matchValue_9, day, month_2, year_1, hour, arg_25, day_3, month_5, year_4, hour_1, arg_34, day_6, month_8, year_7, hour_2, arg_43, day_7, month_9, year_8, hour_3, day_9, month_12, year_10, hour_4, arg_56;
    const matchValue = model.ActivePage;
    switch (msg.tag) {
        case 7: {
            const msg_1 = msg.fields[0];
            switch (msg_1.tag) {
                case 1: {
                    const model_2 = State_Update_deleteToken(model);
                    return State_nextPage(new Route(10, [toString_1(model.LoginKind).toLowerCase()]), model_2);
                }
                case 0: {
                    const browseTo = (url) => {
                        const doc = window.document;
                        const a = doc.createElement("a");
                        a.innerHTML = "Click here";
                        a.href = ("https://documentation.iotpool.fr" + url);
                        a.target = "_blank";
                        a.click();
                        a.remove();
                    };
                    const matchValue_2 = model.ActivePage;
                    if (matchValue_2 == null) {
                        browseTo("");
                        return [model, Cmd_none()];
                    }
                    else {
                        const page = matchValue_2;
                        switch (page.tag) {
                            case 3: {
                                browseTo("/docs/doc1.html#2---ecran-etat-de-mes-capteurs");
                                break;
                            }
                            case 1: {
                                browseTo("/docs/doc1.html#3---ecran-du-capteur-sélectionné");
                                break;
                            }
                            default:
                                browseTo("");
                        }
                        return [model, Cmd_none()];
                    }
                }
                case 6:
                    return State_nextPage(msg_1.fields[0], State_Update_load(model));
                case 12: {
                    const url_1 = msg_1.fields[0];
                    if (url_1 == null) {
                        return [model, Cmd_none()];
                    }
                    else {
                        const url_2 = url_1;
                        const doc_1 = window.document;
                        const a_1 = doc_1.createElement("a");
                        a_1.href = url_2;
                        a_1.target = "_blank";
                        a_1.click();
                        a_1.remove();
                        return [model, Cmd_none()];
                    }
                }
                case 13: {
                    const url_3 = msg_1.fields[0];
                    if (url_3 == null) {
                        return [model, Cmd_none()];
                    }
                    else {
                        const url_4 = url_3;
                        const doc_2 = window.document;
                        const a_2 = doc_2.createElement("a");
                        a_2.href = url_4;
                        a_2.target = "_blank";
                        a_2.click();
                        a_2.remove();
                        return [model, Cmd_none()];
                    }
                }
                case 5:
                    return Commands_getMe(State_Update_load(model));
                case 4:
                    return State_nextPage(new Route(4, []), State_Update_load(model));
                case 7:
                    return State_nextPage(new Route(4, []), State_Update_load(model));
                default: {
                    const patternInput = State_update_1(msg_1, model.Navbar);
                    return [new Types_Model(model.ActivePage, patternInput[0], model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData), Cmd_map((Item) => (new Types_Msg(7, [Item])), patternInput[1])];
                }
            }
        }
        case 39:
            return State_handleGetError(model, msg.fields[0]);
        case 38: {
            const model_12 = State_Update_deleteToken(model);
            return displayError(msg.fields[0].message, model_12);
        }
        case 37:
            return displayError(msg.fields[0].message, model);
        case 40:
            return displaySuccess(model);
        case 35: {
            const matchValue_3 = model.CurrentReportIndex;
            if (matchValue_3 == null) {
                return displayError("Téléchargement impossible.", model);
            }
            else {
                return Commands_getMonthlyReportListed(matchValue_3, model);
            }
        }
        case 36: {
            const matchValue_4 = model.CurrentReportIndex;
            if (matchValue_4 == null) {
                return displayError("Téléchargement impossible.", model);
            }
            else {
                return Commands_getWeeklyReportListed(matchValue_4, model);
            }
        }
        case 41: {
            const response = msg.fields[0];
            const failed = (msg_2, model_19) => {
                const patternInput_1 = displayError(msg_2, model_19);
                const model_21 = patternInput_1[0];
                const patternInput_2 = State_nextPage(new Route(10, [toString_1(model_21.LoginKind).toLowerCase()]), model_21);
                return [patternInput_2[0], Cmd_batch(ofArray([patternInput_1[1], patternInput_2[1]]))];
            };
            if (response.tag === 1) {
                const err_1 = response.fields[0];
                switch (err_1.tag) {
                    case 1:
                        return failed(err_1.fields[0], model);
                    case 2:
                        return failed(err_1.fields[0], model);
                    default:
                        return failed(err_1.fields[1], model);
                }
            }
            else {
                const token = response.fields[0];
                const matchValue_5 = token.Token;
                const matchValue_6 = token.UserId;
                let matchResult, t, uid;
                if (matchValue_5 != null) {
                    if (matchValue_6 != null) {
                        matchResult = 0;
                        t = matchValue_5;
                        uid = matchValue_6;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return State_nextPage(new Route(4, []), State_Update_setTags(token.User.Tags, State_Update_setUser(uid, token.User, State_Update_setToken(t, model))));
                    default:
                        return failed("Utilisateur non reconnu. Merci de ressayer.", model);
                }
            }
        }
        case 14: {
            const sensorId = msg.fields[0];
            const result = msg.fields[1];
            if (result.tag === 1) {
                return State_handleGetError(model, result.fields[0]);
            }
            else {
                const data = result.fields[0];
                if (isEmpty(data.List)) {
                    return displayError("Aucune donnée n\'est disponible pour cette sonde. Désolé.", model);
                }
                else {
                    return State_Update_activePage(new Types_ActivePage(11, [Types_initialModel_7(data.List, sensorId, "Batterie", "BATTERY")]), new Route(18, [sensorId, "Batterie", "BATTERY"]), model);
                }
            }
        }
        case 15: {
            const sensor = msg.fields[0];
            const data_1 = msg.fields[1];
            if (data_1.tag === 1) {
                return State_Update_activePage(new Types_ActivePage(1, [Types_initialModel_8(sensor, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, undefined, model.UserData, model.Sensors)]), new Route(11, [sensor.Name]), model);
            }
            else {
                return State_Update_activePage(new Types_ActivePage(1, [Types_initialModel_8(sensor, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, data_1.fields[0].Docs, model.UserData, model.Sensors)]), new Route(11, [sensor.Name]), model);
            }
        }
        case 26: {
            const result_1 = msg.fields[1];
            if (result_1.tag === 1) {
                return State_handleGetError(model, result_1.fields[0]);
            }
            else {
                return Commands_getProbes(result_1.fields[0], model.FetchHours, State_Update_load(model));
            }
        }
        case 29: {
            const result_2 = msg.fields[1];
            if (result_2.tag === 1) {
                return State_handleGetError(model, result_2.fields[0]);
            }
            else {
                const user_1 = result_2.fields[0];
                User_set(user_1.Id);
                return State_nextPage(msg.fields[0], new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, user_1, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData));
            }
        }
        case 28: {
            const result_3 = msg.fields[0];
            if (result_3.tag === 1) {
                return State_handleGetError(model, result_3.fields[0]);
            }
            else {
                return State_Update_activePage(new Types_ActivePage(0, [Types_initialModel_6(result_3.fields[0].AppOptions)]), new Route(3, []), model);
            }
        }
        case 18: {
            const result_4 = msg.fields[0];
            if (result_4.tag === 1) {
                return State_handleGetError(model, result_4.fields[0]);
            }
            else {
                const list = result_4.fields[0];
                if (isEmpty(list)) {
                    return displayError("Aucun capteur n\'est disponible. Désolé.", model);
                }
                else {
                    return State_Update_activePage(new Types_ActivePage(2, [Types_initialModel_9(list)]), new Route(2, []), model);
                }
            }
        }
        case 32: {
            const result_5 = msg.fields[4];
            const realName = msg.fields[1];
            const from = msg.fields[2];
            const ending = msg.fields[3];
            if (result_5.tag === 1) {
                return Commands_getReportListed(new Types_ReportKind_1(1, []), from, ending, model);
            }
            else {
                const fromTitle = substring(from, 0, from.indexOf("T"));
                const endingTitle = substring(ending, 0, ending.indexOf("T"));
                const date = toText(printf("%s_%s"))(fromTitle)(endingTitle);
                const result_6 = prepare(replace(result_5.fields[0], "\"", ""), toText(printf("%s*%s.pdf"))(realName)(date), msg.fields[0], false);
                const name = toText(printf("%s-%s.pdf"))(realName)(date);
                return Commands_getReportListed(new Types_ReportKind_1(1, []), from, ending, new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, (matchValue_8 = model.PDFData, (matchValue_8 != null) ? append(matchValue_8, singleton([name, result_6])) : singleton([name, result_6]))));
            }
        }
        case 34: {
            const result_7 = msg.fields[4];
            const from_1 = msg.fields[2];
            const ending_1 = msg.fields[3];
            if (result_7.tag === 1) {
                return Commands_getReportListed(new Types_ReportKind_1(0, []), from_1, ending_1, model);
            }
            else {
                const fromTitle_1 = substring(from_1, 0, from_1.indexOf("T"));
                const endingTitle_1 = substring(ending_1, 0, ending_1.indexOf("T"));
                const date_1 = toText(printf("%s_%s"))(fromTitle_1)(endingTitle_1);
                const csvContent_3 = replace(result_7.fields[0], "\"", "");
                const name_1 = toText(printf("%s-%s.csv"))(msg.fields[1])(date_1);
                return Commands_getReportListed(new Types_ReportKind_1(0, []), from_1, ending_1, new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, (matchValue_9 = model.PDFData, (matchValue_9 != null) ? append(matchValue_9, singleton([name_1, csvContent_3])) : singleton([name_1, csvContent_3]))));
            }
        }
        case 33: {
            const matchValue_10 = model.PDFData;
            if (matchValue_10 != null) {
                const list_4 = toArray(map((elem) => (new FileInfo(elem[0], elem[1])), matchValue_10));
                zip.zipFiles(msg.fields[0], list_4);
                return displaySuccess(new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, undefined, undefined, undefined));
            }
            else {
                return displayError("Aucune données trouvées pour les capteurs séléctionnés sur la période choisie.", new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, undefined, undefined, undefined));
            }
        }
        case 21: {
            const result_8 = msg.fields[4];
            if (result_8.tag === 1) {
                return State_handleGetError(model, result_8.fields[0]);
            }
            else {
                let name_4;
                const rn = replace(msg.fields[1], " ", "-");
                name_4 = toText(printf("%s_%s_%02d-%i.csv"))(msg.fields[0])(rn)(msg.fields[2])(msg.fields[3]);
                const encoded = encodeURI(result_8.fields[0]);
                const doc_3 = window.document;
                const a_3 = doc_3.createElement("a");
                a_3.innerHTML = "Click here";
                a_3.href = encoded;
                a_3.target = "_blank";
                a_3.download = name_4;
                doc_3.getElementById("csv").appendChild(a_3);
                a_3.click();
                a_3.remove();
                return [State_Update_loadFinished(model), Cmd_none()];
            }
        }
        case 24: {
            const result_9 = msg.fields[4];
            const full = msg.fields[0];
            if (result_9.tag === 1) {
                return State_handleGetError(model, result_9.fields[0]);
            }
            else {
                const csvContent_5 = result_9.fields[0];
                if (msg.fields[3].tag === 0) {
                    let name_6;
                    let title_6;
                    const matchValue_13 = full.Title;
                    if (matchValue_13 == null) {
                        title_6 = full.Name;
                    }
                    else {
                        const title_5 = replace(matchValue_13, " ", "_");
                        title_6 = toText(printf("%s_%s"))(title_5)(full.Name);
                    }
                    name_6 = toText(printf("%s.csv"))(title_6);
                    const encoded_1 = encodeURI(csvContent_5);
                    const doc_4 = window.document;
                    const a_4 = doc_4.createElement("a");
                    a_4.innerHTML = "Click here";
                    a_4.href = encoded_1;
                    a_4.target = "_blank";
                    a_4.download = name_6;
                    doc_4.getElementById("csv").appendChild(a_4);
                    a_4.click();
                    a_4.remove();
                    return [State_Update_loadFinished(model), Cmd_none()];
                }
                else {
                    let realName_3;
                    const matchValue_11 = full.Title;
                    realName_3 = ((matchValue_11 == null) ? full.Name : matchValue_11);
                    let name_5;
                    let title_3;
                    const matchValue_12 = full.Title;
                    if (matchValue_12 == null) {
                        title_3 = full.Name;
                    }
                    else {
                        const title_2 = replace(matchValue_12, " ", "_");
                        title_3 = toText(printf("%s_%s"))(title_2)(full.Name);
                    }
                    name_5 = toText(printf("%s.pdf"))(title_3);
                    prepareFlat(replace(csvContent_5, "\"", ""), name_5, realName_3, full.Name, msg.fields[1], msg.fields[2], true);
                    return [State_Update_loadFinished(model), Cmd_none()];
                }
            }
        }
        case 23: {
            const result_10 = msg.fields[5];
            if (result_10.tag === 1) {
                return State_handleGetError(model, result_10.fields[0]);
            }
            else {
                let name_8;
                const rn_1 = replace(msg.fields[1], " ", "-");
                name_8 = toText(printf("%s_%s_semaine%i.csv"))(msg.fields[0])(rn_1)(msg.fields[4]);
                const encoded_2 = encodeURI(result_10.fields[0]);
                const doc_5 = window.document;
                const a_5 = doc_5.createElement("a");
                a_5.innerHTML = "Click here";
                a_5.href = encoded_2;
                a_5.target = "_blank";
                a_5.download = name_8;
                doc_5.getElementById("csv").appendChild(a_5);
                a_5.click();
                a_5.remove();
                return [State_Update_loadFinished(model), Cmd_none()];
            }
        }
        case 20: {
            const result_11 = msg.fields[0];
            if (result_11.tag === 1) {
                return State_handleGetError(model, result_11.fields[0]);
            }
            else {
                const list_5 = result_11.fields[0];
                if (isEmpty(list_5.Docs)) {
                    return displayError("Aucun capteur n\'est disponible.", model);
                }
                else {
                    const matchValue_14 = model.UserData;
                    if (matchValue_14 != null) {
                        const model_51 = new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, list_5.Docs, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData);
                        return State_Update_activePage(new Types_ActivePage(4, [Types_initialModel_10(list_5.Docs, matchValue_14)]), new Route(5, []), model_51);
                    }
                    else {
                        return Commands_refreshUser(new Route(5, []), State_Update_load(model));
                    }
                }
            }
        }
        case 19: {
            const result_12 = msg.fields[0];
            if (result_12.tag === 1) {
                return State_handleGetError(model, result_12.fields[0]);
            }
            else {
                const list_6 = result_12.fields[0];
                if (isEmpty(list_6.Docs)) {
                    return displayError("Aucun capteur n\'est disponible. Désolé.", model);
                }
                else {
                    const startDate = toString(addDays(now_4(), -1), "yyyy-MM-dd");
                    const endDate = toString(now_4(), "yyyy-MM-dd");
                    const model_53 = new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, startDate, endDate, list_6.Docs, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData);
                    return State_Update_activePage(new Types_ActivePage(3, [Types_initialModel_11(list_6.Docs, startDate, endDate, model.UserData)]), new Route(4, []), model_53);
                }
            }
        }
        default:
            if (matchValue != null) {
                const page_1 = matchValue;
                const msg_6 = msg;
                let matchResult_1, md, msg_7, md_1, msg_8, md_2, msg_9, md_3, msg_11, md_4, msg_13, md_5, msg_14, md_6, msg_15, md_7, msg_16, md_8, msg_17, md_9, msg_19, md_10, msg_21, md_11, msg_23;
                switch (page_1.tag) {
                    case 0: {
                        if (msg_6.tag === 0) {
                            matchResult_1 = 0;
                            md = page_1.fields[0];
                            msg_7 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 11: {
                        if (msg_6.tag === 12) {
                            matchResult_1 = 1;
                            md_1 = page_1.fields[0];
                            msg_8 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 1: {
                        if (msg_6.tag === 6) {
                            matchResult_1 = 2;
                            md_2 = page_1.fields[0];
                            msg_9 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 12: {
                        if (msg_6.tag === 13) {
                            matchResult_1 = 3;
                            md_3 = page_1.fields[0];
                            msg_11 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 2: {
                        if (msg_6.tag === 2) {
                            matchResult_1 = 4;
                            md_4 = page_1.fields[0];
                            msg_13 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 3: {
                        if (msg_6.tag === 3) {
                            matchResult_1 = 5;
                            md_5 = page_1.fields[0];
                            msg_14 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 4: {
                        if (msg_6.tag === 4) {
                            matchResult_1 = 6;
                            md_6 = page_1.fields[0];
                            msg_15 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 6: {
                        if (msg_6.tag === 1) {
                            matchResult_1 = 7;
                            md_7 = page_1.fields[0];
                            msg_16 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 8: {
                        if (msg_6.tag === 9) {
                            matchResult_1 = 8;
                            md_8 = page_1.fields[0];
                            msg_17 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 9: {
                        if (msg_6.tag === 10) {
                            matchResult_1 = 9;
                            md_9 = page_1.fields[0];
                            msg_19 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 10: {
                        if (msg_6.tag === 11) {
                            matchResult_1 = 10;
                            md_10 = page_1.fields[0];
                            msg_21 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    case 7: {
                        if (msg_6.tag === 8) {
                            matchResult_1 = 11;
                            md_11 = page_1.fields[0];
                            msg_23 = msg_6.fields[0];
                        }
                        else {
                            matchResult_1 = 12;
                        }
                        break;
                    }
                    default:
                        matchResult_1 = 12;
                }
                switch (matchResult_1) {
                    case 0:
                        return State_nextPage(new Route(4, []), State_Update_load(model));
                    case 1:
                        if (msg_8.tag === 4) {
                            return State_nextPage(msg_8.fields[0], State_Update_load(model));
                        }
                        else {
                            const patternInput_3 = State_update_2(msg_8, md_1);
                            return State_Update_routeMessage(new Types_ActivePage(11, [patternInput_3[0]]), (Item_1) => (new Types_Msg(12, [Item_1])), patternInput_3[1], model);
                        }
                    case 2:
                        switch (msg_9.tag) {
                            case 2:
                                return State_nextPage(msg_9.fields[0], State_Update_load(model));
                            case 59:
                                return State_nextPage(new Route(11, [msg_9.fields[0]]), State_Update_load(new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, msg_9.fields[1], model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData)));
                            case 63: {
                                const from_4 = msg_9.fields[1];
                                const ending_4 = msg_9.fields[2];
                                const now = now_4();
                                const frenchHour = localFormat(french, "HH", toLocalTime(now));
                                const utcHour = hour_5(toUniversalTime(now)) | 0;
                                const diff = Math.abs(utcHour - parse(frenchHour, 511, false, 32)) | 0;
                                const ymd = map_1((value_4) => parse(value_4, 511, false, 32), from_4.split("-"), Int32Array);
                                const year_3 = item_1(0, ymd) | 0;
                                const month_4 = item_1(1, ymd) | 0;
                                const day_2 = item_1(2, ymd) | 0;
                                const endymd = map_1((value_5) => parse(value_5, 511, false, 32), ending_4.split("-"), Int32Array);
                                const endyear = item_1(0, endymd) | 0;
                                const endmonth = item_1(1, endymd) | 0;
                                const endday = item_1(2, endymd) | 0;
                                return Commands_getDataFromDateToDate(msg_9.fields[0], (day = (day_2 | 0), (month_2 = (month_4 | 0), (year_1 = (year_3 | 0), (diff > 0) ? ((hour = ((24 - diff) | 0), (arg_25 = (((day > 1) ? (day - 1) : day) | 0), toText(printf("%i-%02d-%02dT00:00:00Z"))(year_1)(month_2)(arg_25)))) : toText(printf("%i-%02d-%02dT00:00:00Z"))(year_1)(month_2)(day)))), toText(printf("%i-%02d-%02dT23:59:59Z"))(endyear)(endmonth)(endday), State_Update_load(new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, from_4, ending_4, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData)));
                            }
                            case 64: {
                                const from_5 = msg_9.fields[1];
                                const ending_5 = msg_9.fields[2];
                                const now_1 = now_4();
                                const frenchHour_1 = localFormat(french, "HH", toLocalTime(now_1));
                                const utcHour_1 = hour_5(toUniversalTime(now_1)) | 0;
                                const diff_1 = Math.abs(utcHour_1 - parse(frenchHour_1, 511, false, 32)) | 0;
                                const ymd_1 = map_1((value_6) => parse(value_6, 511, false, 32), from_5.split("-"), Int32Array);
                                const year_6 = item_1(0, ymd_1) | 0;
                                const month_7 = item_1(1, ymd_1) | 0;
                                const day_5 = item_1(2, ymd_1) | 0;
                                const endymd_1 = map_1((value_7) => parse(value_7, 511, false, 32), ending_5.split("-"), Int32Array);
                                const endyear_1 = item_1(0, endymd_1) | 0;
                                const endmonth_1 = item_1(1, endymd_1) | 0;
                                const endday_1 = item_1(2, endymd_1) | 0;
                                return Commands_getDataFromDateToDateForDownload(msg_9.fields[0], (day_3 = (day_5 | 0), (month_5 = (month_7 | 0), (year_4 = (year_6 | 0), (diff_1 > 0) ? ((hour_1 = ((24 - diff_1) | 0), (arg_34 = (((day_3 > 1) ? (day_3 - 1) : day_3) | 0), toText(printf("%i-%02d-%02dT00:00:00Z"))(year_4)(month_5)(arg_34)))) : toText(printf("%i-%02d-%02dT00:00:00Z"))(year_4)(month_5)(day_3)))), toText(printf("%i-%02d-%02dT23:59:59Z"))(endyear_1)(endmonth_1)(endday_1), new OutputKind(0, []), State_Update_load(new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, from_5, ending_5, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData)));
                            }
                            case 65: {
                                const from_6 = msg_9.fields[1];
                                const ending_6 = msg_9.fields[2];
                                const now_2 = now_4();
                                const frenchHour_2 = localFormat(french, "HH", toLocalTime(now_2));
                                const utcHour_2 = hour_5(toUniversalTime(now_2)) | 0;
                                const diff_2 = Math.abs(utcHour_2 - parse(frenchHour_2, 511, false, 32)) | 0;
                                const ymd_2 = map_1((value_8) => parse(value_8, 511, false, 32), from_6.split("-"), Int32Array);
                                const year_9 = item_1(0, ymd_2) | 0;
                                const month_10 = item_1(1, ymd_2) | 0;
                                const day_8 = item_1(2, ymd_2) | 0;
                                const endymd_2 = map_1((value_9) => parse(value_9, 511, false, 32), ending_6.split("-"), Int32Array);
                                const endyear_2 = item_1(0, endymd_2) | 0;
                                const endmonth_2 = item_1(1, endymd_2) | 0;
                                const endday_2 = item_1(2, endymd_2) | 0;
                                return Commands_getDataFromDateToDateForDownload(msg_9.fields[0], (day_6 = (day_8 | 0), (month_8 = (month_10 | 0), (year_7 = (year_9 | 0), (diff_2 > 0) ? ((hour_2 = ((24 - diff_2) | 0), (arg_43 = (((day_6 > 1) ? (day_6 - 1) : day_6) | 0), toText(printf("%i-%02d-%02dT00:00:00Z"))(year_7)(month_8)(arg_43)))) : toText(printf("%i-%02d-%02dT00:00:00Z"))(year_7)(month_8)(day_6)))), (day_7 = (endday_2 | 0), (month_9 = (endmonth_2 | 0), (year_8 = (endyear_2 | 0), (diff_2 > 0) ? ((hour_3 = ((23 - diff_2) | 0), toText(printf("%i-%02d-%02dT%02d:59:59Z"))(year_8)(month_9)(day_7)(hour_3))) : toText(printf("%i-%02d-%02dT23:59:59Z"))(year_8)(month_9)(day_7)))), new OutputKind(1, []), State_Update_load(new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, from_6, ending_6, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData)));
                            }
                            case 70: {
                                toConsole(printf("fetch error"));
                                return State_handleGetError(model, msg_9.fields[0]);
                            }
                            case 71: {
                                toConsole(printf("dispmlay error"));
                                return displayError(msg_9.fields[0], model);
                            }
                            case 69: {
                                toConsole(printf("error"));
                                return displayError(msg_9.fields[0].message, model);
                            }
                            case 72: {
                                toConsole(printf("success"));
                                return displaySuccess(model);
                            }
                            case 51:
                                return displaySuccess(model);
                            case 27: {
                                const patternInput_4 = State_update_3(msg_9, md_2);
                                return State_Update_routeMessage(new Types_ActivePage(1, [patternInput_4[0]]), (Item_2) => (new Types_Msg(6, [Item_2])), patternInput_4[1], State_Update_load(model));
                            }
                            case 66: {
                                const patternInput_5 = State_update_3(msg_9, md_2);
                                return State_Update_routeMessage(new Types_ActivePage(1, [patternInput_5[0]]), (Item_3) => (new Types_Msg(6, [Item_3])), patternInput_5[1], State_Update_loadFinished(model));
                            }
                            case 67: {
                                const patternInput_6 = State_update_3(msg_9, md_2);
                                return State_Update_routeMessage(new Types_ActivePage(1, [patternInput_6[0]]), (Item_4) => (new Types_Msg(6, [Item_4])), patternInput_6[1], State_Update_loadFinished(model));
                            }
                            case 47: {
                                const patternInput_7 = State_update_3(msg_9, md_2);
                                return State_Update_routeMessage(new Types_ActivePage(1, [patternInput_7[0]]), (Item_5) => (new Types_Msg(6, [Item_5])), patternInput_7[1], State_Update_load(model));
                            }
                            default: {
                                const patternInput_8 = State_update_3(msg_9, md_2);
                                return State_Update_routeMessage(new Types_ActivePage(1, [patternInput_8[0]]), (Item_6) => (new Types_Msg(6, [Item_6])), patternInput_8[1], model);
                            }
                        }
                    case 3:
                        switch (msg_11.tag) {
                            case 4:
                                return displayError(msg_11.fields[0], model);
                            case 0:
                                return State_nextPage(msg_11.fields[0], State_Update_load(model));
                            case 5: {
                                toConsole(printf("error"));
                                return displayError(msg_11.fields[0].message, model);
                            }
                            case 1: {
                                const patternInput_9 = State_update_4(msg_11, md_3);
                                return State_Update_routeMessage(new Types_ActivePage(12, [patternInput_9[0]]), (Item_7) => (new Types_Msg(13, [Item_7])), patternInput_9[1], State_Update_load(model));
                            }
                            case 3: {
                                const patternInput_10 = State_update_4(msg_11, md_3);
                                return State_Update_routeMessage(new Types_ActivePage(12, [patternInput_10[0]]), (Item_8) => (new Types_Msg(13, [Item_8])), patternInput_10[1], State_Update_loadFinished(model));
                            }
                            case 6: {
                                toConsole(printf("success"));
                                return displaySuccess(model);
                            }
                            default: {
                                const patternInput_11 = State_update_4(msg_11, md_3);
                                return State_Update_routeMessage(new Types_ActivePage(12, [patternInput_11[0]]), (Item_9) => (new Types_Msg(13, [Item_9])), patternInput_11[1], model);
                            }
                        }
                    case 4:
                        if (msg_13.tag === 1) {
                            return State_nextPage(new Route(11, [msg_13.fields[0]]), State_Update_load(model));
                        }
                        else {
                            const patternInput_12 = State_update_5(msg_13, md_4);
                            return State_Update_routeMessage(new Types_ActivePage(2, [patternInput_12[0]]), (Item_10) => (new Types_Msg(2, [Item_10])), patternInput_12[1], model);
                        }
                    case 5:
                        switch (msg_14.tag) {
                            case 1:
                                return State_nextPage(new Route(11, [msg_14.fields[0]]), State_Update_load(model));
                            case 11:
                                return Commands_getMonthlyReportListed(msg_14.fields[1], new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, msg_14.fields[0], model.CurrentReportIndex, model.PDFData));
                            case 19: {
                                const updated_12 = new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, msg_14.fields[0], model.CurrentReportIndex, model.PDFData);
                                const now_3 = now_4();
                                const frenchHour_3 = localFormat(french, "HH", toLocalTime(now_3));
                                const utcHour_3 = hour_5(toUniversalTime(now_3)) | 0;
                                const diff_3 = Math.abs(utcHour_3 - parse(frenchHour_3, 511, false, 32)) | 0;
                                const ymd_3 = map_1((value_10) => parse(value_10, 511, false, 32), msg_14.fields[2].split("-"), Int32Array);
                                const year_12 = item_1(0, ymd_3) | 0;
                                const month_14 = item_1(1, ymd_3) | 0;
                                const day_11 = item_1(2, ymd_3) | 0;
                                const endymd_3 = map_1((value_11) => parse(value_11, 511, false, 32), msg_14.fields[3].split("-"), Int32Array);
                                const endyear_3 = item_1(0, endymd_3) | 0;
                                const endmonth_3 = item_1(1, endymd_3) | 0;
                                const endday_3 = item_1(2, endymd_3) | 0;
                                return Commands_getReportListed(msg_14.fields[1], (day_9 = (day_11 | 0), (month_12 = (month_14 | 0), (year_10 = (year_12 | 0), (diff_3 > 0) ? ((hour_4 = ((24 - diff_3) | 0), (arg_56 = (((day_9 > 1) ? (day_9 - 1) : day_9) | 0), toText(printf("%i-%02d-%02dT00:00:00Z"))(year_10)(month_12)(arg_56)))) : toText(printf("%i-%02d-%02dT00:00:00Z"))(year_10)(month_12)(day_9)))), toText(printf("%i-%02d-%02dT23:59:59Z"))(endyear_3)(endmonth_3)(endday_3), updated_12);
                            }
                            case 12:
                                return Commands_getWeeklyReportListed(msg_14.fields[1], new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, model.UserData, model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, msg_14.fields[0], model.CurrentReportIndex, model.PDFData));
                            default: {
                                const patternInput_13 = State_update_6(msg_14, md_5);
                                return State_Update_routeMessage(new Types_ActivePage(3, [patternInput_13[0]]), (Item_11) => (new Types_Msg(3, [Item_11])), patternInput_13[1], model);
                            }
                        }
                    case 6:
                        switch (msg_15.tag) {
                            case 12:
                                return displayError(msg_15.fields[0], model);
                            case 11:
                                return displaySuccess(new Types_Model(model.ActivePage, model.Navbar, model.CurrentRoute, model.Count, model.IsLoading, model.User, msg_15.fields[0], model.Tags, model.LoginKind, model.FetchHours, model.GetGraphStartDate, model.GetGraphEndDate, model.Sensors, model.SensorsToDownload, model.CurrentReportIndex, model.PDFData));
                            case 13:
                                return State_nextPage(new Route(11, [msg_15.fields[0]]), State_Update_load(model));
                            default: {
                                const patternInput_14 = State_update_7(msg_15, md_6);
                                return State_Update_routeMessage(new Types_ActivePage(4, [patternInput_14[0]]), (Item_12) => (new Types_Msg(4, [Item_12])), patternInput_14[1], model);
                            }
                        }
                    case 7: {
                        const patternInput_15 = State_update_8(msg_16, md_7);
                        return State_Update_routeMessage(new Types_ActivePage(6, [patternInput_15[0]]), (Item_13) => (new Types_Msg(1, [Item_13])), patternInput_15[1], model);
                    }
                    case 8:
                        switch (msg_17.tag) {
                            case 3: {
                                const model_107 = State_Update_load(model);
                                return State_nextPage(new Route(10, [toString_1(model.LoginKind).toLowerCase()]), model_107);
                            }
                            case 7:
                                return displayError("Aucune adresse email connue sur ce compte. Veuillez contacter votre fournisseur.", model);
                            case 8:
                                return displayError("Identifiant inconnu", model);
                            case 6: {
                                const patternInput_16 = displayCustomSuccess("Un email avec les instructions a été envoyé.", model);
                                const model_111 = patternInput_16[0];
                                const patternInput_17 = State_nextPage(new Route(10, [toString_1(model_111.LoginKind).toLowerCase()]), model_111);
                                return [patternInput_17[0], Cmd_batch(ofArray([patternInput_16[1], patternInput_17[1]]))];
                            }
                            default: {
                                const patternInput_18 = State_update_9(msg_17, md_8);
                                return State_Update_routeMessage(new Types_ActivePage(8, [patternInput_18[0]]), (Item_14) => (new Types_Msg(9, [Item_14])), patternInput_18[1], model);
                            }
                        }
                    case 9:
                        switch (msg_19.tag) {
                            case 9: {
                                const model_116 = State_Update_load(model);
                                return State_nextPage(new Route(10, [toString_1(model.LoginKind).toLowerCase()]), model_116);
                            }
                            case 6:
                                return displayError("Aucune adresse email connue sur ce compte. Veuillez contacter votre fournisseur.", model);
                            case 7:
                                return displayError("Identifiant inconnu", model);
                            case 5: {
                                const patternInput_19 = displayCustomSuccess("Un email avec le nouveau mot de passe a été envoyé. Merci de le consulter.", model);
                                const model_120 = patternInput_19[0];
                                const patternInput_20 = State_nextPage(new Route(10, [toString_1(model_120.LoginKind).toLowerCase()]), model_120);
                                return [patternInput_20[0], Cmd_batch(ofArray([patternInput_19[1], patternInput_20[1]]))];
                            }
                            default: {
                                const patternInput_21 = State_update_10(msg_19, md_9);
                                return State_Update_routeMessage(new Types_ActivePage(9, [patternInput_21[0]]), (Item_15) => (new Types_Msg(10, [Item_15])), patternInput_21[1], model);
                            }
                        }
                    case 10:
                        switch (msg_21.tag) {
                            case 11:
                                return State_nextPage(new Route(4, []), State_Update_load(model));
                            case 10:
                                return displayError("Erreur lors de la génération du mot de passe. Merci de réessayer.", model);
                            case 9:
                                return displayError("Erreur lors de la génération du mot de passe. Merci de réessayer.", model);
                            case 7:
                                return displayCustomSuccess("Un email avec le nouveau mot de passe a été envoyé. Merci de le consulter.", model);
                            default: {
                                const patternInput_22 = State_update_11(msg_21, md_10);
                                return State_Update_routeMessage(new Types_ActivePage(10, [patternInput_22[0]]), (Item_16) => (new Types_Msg(11, [Item_16])), patternInput_22[1], model);
                            }
                        }
                    case 11:
                        switch (msg_23.tag) {
                            case 4:
                                return State_nextPage(msg_23.fields[0], State_Update_load(model));
                            case 0:
                                return [State_Update_load(model), Cmd_none()];
                            case 9: {
                                const token_1 = msg_23.fields[0];
                                const matchValue_16 = token_1.Token;
                                const matchValue_17 = token_1.UserId;
                                let matchResult_2, t_4, uid_1;
                                if (matchValue_16 != null) {
                                    if (matchValue_17 != null) {
                                        matchResult_2 = 0;
                                        t_4 = matchValue_16;
                                        uid_1 = matchValue_17;
                                    }
                                    else {
                                        matchResult_2 = 1;
                                    }
                                }
                                else {
                                    matchResult_2 = 1;
                                }
                                switch (matchResult_2) {
                                    case 0:
                                        return State_nextPage(new Route(4, []), State_Update_setTags(token_1.User.Tags, State_Update_setUser(uid_1, token_1.User, State_Update_setToken(t_4, model))));
                                    default:
                                        return displayError("Utilisateur non reconnu. Merci de ressayer.", model);
                                }
                            }
                            case 2:
                                if (msg_23.fields[0].tag === 1) {
                                    const patternInput_24 = State_update_12(msg_23, md_11);
                                    return State_Update_routeMessage(new Types_ActivePage(7, [patternInput_24[0]]), (Item_18) => (new Types_Msg(8, [Item_18])), patternInput_24[1], State_Update_loadFinished(model));
                                }
                                else {
                                    const patternInput_23 = State_update_12(msg_23, md_11);
                                    return State_Update_routeMessage(new Types_ActivePage(7, [patternInput_23[0]]), (Item_17) => (new Types_Msg(8, [Item_17])), patternInput_23[1], model);
                                }
                            default: {
                                const patternInput_25 = State_update_12(msg_23, md_11);
                                return State_Update_routeMessage(new Types_ActivePage(7, [patternInput_25[0]]), (Item_19) => (new Types_Msg(8, [Item_19])), patternInput_25[1], model);
                            }
                        }
                    default:
                        return [model, Cmd_none()];
                }
            }
            else {
                return [model, Cmd_none()];
            }
    }
}

export function View_root(model, dispatch) {
    const pageLoader = (model_1) => pageLoader_1(ofArray([new Option(1, [new Color_IColor(0, [])]), new Option(0, [model_1.IsLoading])]), singleton(h1(empty())(singleton("Chargement de vos données. Veuillez patienter."))));
    const publicView = (model_2, dispatch_1, view) => {
        if (Token_exists()) {
            const props = [["style", {
                backgroundColor: "white",
            }]];
            const children = [pageLoader(model_2), View_root_1(model_2.Navbar, model_2.UserData, model_2.LoginKind, (arg) => {
                dispatch_1(new Types_Msg(7, [arg]));
            }), container(ofArray([new Option_1(0, []), new Option_1(3, [singleton(["style", {
                marginTop: "1.5rem",
            }])])]), singleton(view))];
            return react.createElement("div", keyValueList(props, 1), ...children);
        }
        else {
            return hero(ofArray([new Option_2(5, []), new Option_2(6, [new Color_IColor(2, [])])]), ofArray([pageLoader(model_2), body(empty(), singleton(container(ofArray([new Option_1(0, []), new Option_1(5, [singleton(new Modifier_IModifier(5, [new Screen(0, []), new TextAlignment_Option(0, [])]))])]), singleton(view))))]));
        }
    };
    const matchValue = model.ActivePage;
    if (matchValue == null) {
        return hero(ofArray([new Option_2(5, []), new Option_2(6, [new Color_IColor(2, [])])]), singleton(body(empty(), singleton(container(singleton(new Option_1(5, [singleton(new Modifier_IModifier(5, [new Screen(0, []), new TextAlignment_Option(0, [])]))])), singleton(icon(singleton(new Option_3(0, [new Size_ISize(2, [])])), singleton(Fa_i(ofArray([new Fa_IconOption(11, ["fas fa-spinner"]), new Fa_IconOption(0, [new Fa_ISize(7, [])]), new Fa_IconOption(12, [])]), [])))))))));
    }
    else {
        const page = matchValue;
        switch (page.tag) {
            case 6:
                return publicView(model, dispatch, View_root_2(page.fields[0], (arg_2) => {
                    dispatch(new Types_Msg(1, [arg_2]));
                }));
            case 7:
                return publicView(model, dispatch, View_root_3(page.fields[0], (arg_3) => {
                    dispatch(new Types_Msg(8, [arg_3]));
                }));
            case 9:
                return publicView(model, dispatch, View_root_4(page.fields[0], (arg_4) => {
                    dispatch(new Types_Msg(10, [arg_4]));
                }));
            case 10:
                return publicView(model, dispatch, View_root_5(page.fields[0], (arg_5) => {
                    dispatch(new Types_Msg(11, [arg_5]));
                }));
            case 8:
                return publicView(model, dispatch, View_root_6(page.fields[0], (arg_6) => {
                    dispatch(new Types_Msg(9, [arg_6]));
                }));
            case 11:
                return publicView(model, dispatch, View_root_7(page.fields[0], (arg_7) => {
                    dispatch(new Types_Msg(12, [arg_7]));
                }));
            case 1:
                return publicView(model, dispatch, View_root_8(page.fields[0], (arg_8) => {
                    dispatch(new Types_Msg(6, [arg_8]));
                }));
            case 12:
                return hero(ofArray([new Option_2(5, []), new Option_2(6, [new Color_IColor(2, [])])]), ofArray([pageLoader(model), body(empty(), singleton(container(ofArray([new Option_1(0, []), new Option_1(5, [singleton(new Modifier_IModifier(5, [new Screen(0, []), new TextAlignment_Option(0, [])]))])]), singleton(View_root_9(page.fields[0], (arg_9) => {
                    dispatch(new Types_Msg(13, [arg_9]));
                })))))]));
            case 2:
                return publicView(model, dispatch, View_root_10(page.fields[0], (arg_10) => {
                    dispatch(new Types_Msg(2, [arg_10]));
                }));
            case 4:
                return publicView(model, dispatch, View_root_11(page.fields[0], (arg_11) => {
                    dispatch(new Types_Msg(4, [arg_11]));
                }));
            case 3:
                return publicView(model, dispatch, View_root_12(page.fields[0], (arg_12) => {
                    dispatch(new Types_Msg(3, [arg_12]));
                }));
            case 5:
                return publicView(model, dispatch, View_root_13(page.fields[0], (arg_13) => {
                    dispatch(new Types_Msg(5, [arg_13]));
                }));
            default:
                return publicView(model, dispatch, View_root_14(page.fields[0], (arg_1) => {
                    dispatch(new Types_Msg(0, [arg_1]));
                }));
        }
    }
}

